export function createPoller(callback, defaultDelay = 30000) {

  let stopped = true;
  let timer = null;

  async function run() {
    if (stopped) return;

    let nextDelay = defaultDelay;

    try {
      const result = await callback();

      // callback can return custom delay
      if (typeof result === "number") {
        nextDelay = result;
      }

    } catch (err) {
      console.error("Poller error:", err);
    }

    if (!stopped) {
      timer = setTimeout(run, nextDelay);
    }
  }

  return {
    start() {
      if (!stopped) return;
      stopped = false;
      run();
    },

    stop() {
      stopped = true;
      if (timer) clearTimeout(timer);
    }
  };
}